import { ContentWrapper } from '@/components/_common';
import { Card, Col, Image, Row, Skeleton } from 'antd';
import React from 'react';
import './style.less';

import { HelpItem } from '@/core/domain/helpcenter/HelpItems/HelpItems.types';
import HelpCenterFavoriteToggle from '../HelpCenterFavoriteToogle';

interface Props {
  loading: boolean;
  items: HelpItem[];
}

const HelpCenterWorksheets: React.FC<Props> = ({ loading, items }) => {
  const { Meta } = Card;

  function handleRedirectLink(item: HelpItem) {
    if (item?.link) window.open(item.link, '_blank');
  }

  return (
    <ContentWrapper style={{ width: '100%' }}>
      <Skeleton active loading={loading}>
        <Row gutter={[30, 30]}>
          {items?.map((item) => (
            <Col key={item.id} span={24} md={12} lg={8} xl={6}>
              <Card
                className="work-sheets-card"
                hoverable
                cover={
                  <Image
                    preview={false}
                    alt={item.content}
                    src={item.thumbnail}
                  />
                }
              >
                <Row gutter={[12, 12]}>
                  <Col span={24} onClick={() => handleRedirectLink(item)}>
                    <Meta title={item.title} description={item.content} />
                  </Col>

                  <Col span={24}>
                    <HelpCenterFavoriteToggle helpItem={item} />
                  </Col>
                </Row>
              </Card>
            </Col>
          ))}
        </Row>
      </Skeleton>
    </ContentWrapper>
  );
};

export default HelpCenterWorksheets;
